
const NODE_API_PROD_URL = 'https://2q2amqd2r9.execute-api.us-east-1.amazonaws.com/dev';


export const ROOT_URL = process.env.NODE_ENV === "production" ? `${NODE_API_PROD_URL}` : ""
